import React from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Alert,
  Button,
  Container,
  Form,
  FormControl,
  Navbar,
  Tab,
  Table,
  Tabs
} from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import TableRow from "./TableRow";
import GenerateYAML from "./GenerateYAML";
import ModelMembers from "./ModelMembers";
import Controller from "./Controller";
import ViewCount from "./ViewCount";

const initialList = [
  // {
  //   id: "a",
  //   name: "test1",
  //   model: true,
  //   controller: "Default",
  //   seeder: false,
  //   migration: false,
  //   isComplete: false,
  //   members: [],
  //   controllerText: "",
  //   belongsTo: "Posts",
  //   belongsToMany: "Posts, Users",
  //   hasMany: "Posts, Users"
  // },
  // {
  //   id: "b",
  //   name: "test2",
  //   model: true,
  //   controller: "Default",
  //   seeder: false,
  //   migration: false,
  //   isComplete: false,
  //   members: [],
  //   controllerText: "",
  //   belongsTo: "Posts",
  //   belongsToMany: "Posts, Users",
  //   hasMany: "Posts, Users"
  // }
];

const App = () => {
  const [list, setList] = React.useState(initialList);
  const [name, setName] = React.useState("");

  function handleChange(event) {
    setName(event.target.value);
  }

  function handleAdd() {
    const newList = list.concat({
      id: uuidv4(),
      name,
      model: true,
      controller: "Default",
      seeder: true,
      migration: true,
      isComplete: true,
      members: [],
      controllerText: "",
      belongsTo: "",
      belongsToMany: "",
      hasMany: ""
    });

    setList(newList);

    setName("");
  }

  function handleToggleComplete(id, key, value) {
    //console.log(value);
    const newList = list.map((item) => {
      if (item.id === id) {
        const updatedItem = {
          ...item,
          [key]: value
        };

        return updatedItem;
      }

      return item;
    });

    setList(newList);
  }

  function handleRemove(id) {
    const newList = list.filter((item) => item.id !== id);

    setList(newList);
  }

  return (
    <div>
      <Container>
        <Navbar expand="lg" variant="light" bg="light">
          <Container>
            <Navbar.Brand href="#">
              {" "}
              LARAFAST | Laravel Blueprint YAML Creator
            </Navbar.Brand>
          </Container>
        </Navbar>
        <hr />
        <div class="row row-cols-1 row-cols-lg-2 g-2 g-lg-3">
          <div class="col col-lg-3 ">
            <div class="p-3 border bg-light">
              <AddItem name={name} onChange={handleChange} onAdd={handleAdd} />
            </div>
          </div>
          <div class="col col-lg-9">
            <div class="p-3 border bg-light">
              <Tabs
                id="uncontrolled-tab-example"
                className="mb-3"
                defaultActiveKey="Summary"
              >
                {list.length > 0 && (
                  <Tab eventKey="Summary" title="Summary">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Model</th>
                          <th>Controller</th>
                          <th>Seeder</th>
                          {/* <th>Migration</th> */}
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <TableRow
                        list={list}
                        onToggleComplete={handleToggleComplete}
                        onRemove={handleRemove}
                      />
                    </Table>
                  </Tab>
                )}

                {list.map((item, ixx) => (
                  <Tab eventKey={item.name} title={item.name}>
                    <ModelMembers
                      key={ixx}
                      updateMembers={handleToggleComplete}
                      {...item}
                    />
                    <br />
                    <b>Relationships for: {item.name}</b>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>belongsTo</th>
                          <th>belongsToMany</th>
                          <th>hasMany</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <FormControl
                              as="textarea"
                              placeholder="Use comma separated list of multiple values"
                              value={item.belongsTo}
                              onChange={(e) =>
                                handleToggleComplete(
                                  item.id,
                                  "belongsTo",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <FormControl
                              as="textarea"
                              placeholder="Use comma separated list of multiple values"
                              value={item.belongsToMany}
                              onChange={(e) =>
                                handleToggleComplete(
                                  item.id,
                                  "belongsToMany",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <FormControl
                              as="textarea"
                              placeholder="Use comma separated list of multiple values"
                              value={item.hasMany}
                              onChange={(e) =>
                                handleToggleComplete(
                                  item.id,
                                  "hasMany",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    {item.controller !== "Custom" && (
                      <Alert variant="info">
                        <b>Info:</b> To customize controllers, from the
                        "Summary" tab select "Custom" for Controllers from the
                        dropdown.
                      </Alert>
                    )}
                    {item.controller === "Custom" && (
                      <div>
                        <b>Controllers for: {item.name}</b>
                        <Controller
                          id={item.id}
                          onToggleComplete={handleToggleComplete}
                        />
                        <br />
                      </div>
                    )}
                  </Tab>
                ))}
              </Tabs>
              <GenerateYAML list={list} />
            </div>
          </div>
        </div>

        {/* <List
        list={list}
        onToggleComplete={handleToggleComplete}
        onRemove={handleRemove}
      /> */}
        <br />
        <ViewCount />
      </Container>
    </div>
  );
};

const AddItem = ({ name, onChange, onAdd }) => (
  <div>
    <p>
      <Form.Label>Model or table name (singular)</Form.Label>
      <Form.Control
        type="text"
        autoFocus
        placeholder="Enter a model / table name"
        value={name}
        onChange={onChange}
      />
    </p>
    <Button onClick={onAdd}>Add</Button>
  </div>
);

const List = ({ list, onToggleComplete, onRemove }) => (
  <ul>
    {list.map((item) => (
      <li key={item.id}>
        {item.id} {item.name} {item.isComplete + ""} {item.model + ""}{" "}
        {item.controller + ""} {item.seeder + ""} {item.migration + ""}
        {
          <Button onClick={() => onToggleComplete(item.id)}>
            {item.isComplete ? "Undo" : "Done"}
          </Button>
        }
        {/* <Button onClick={() => onRemove(item.id)}>Remove</Button> */}
      </li>
    ))}
  </ul>
);
export default App;

// {item.name} {item.isComplete + ""}
//         <Button onClick={() => onToggleComplete(item.id)}>
//           {item.isComplete ? "Undo" : "Done"}
//         </Button>
//         <Button onClick={() => onRemove(item.id)}>Remove</Button>
